import React from "react";
import _ from "lodash";
import set from "@rill/set";
import submit from "submit-form";
import { withTranslation } from "react-i18next";

import loadStripeCard from "../../../utils/stripe-card";
import SettingsNav from "../../../parts/settings-nav";
import CancelAccountModal from "../../../parts/modals/cancel-account";
import UpdatePaymentModal from "../../../parts/modals/update-payment";

import UpgradeConfirmationModal from "../../../parts/modals/upgrade-confirmation";
import { STRIPE, US_STATES, AU_STATES } from "../../../constants";
import StripeCardComponent from "../../../parts/StripeCardComponent";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import { SettingsBackHandler } from "../../coaching-portal/settings/components/SettingsBackHandler";
import SvgIcon from "../../../parts/SvgIcon";

const { PLANS } = STRIPE;

const FORM_ID = "billing-card-address-details";

class BillingDetailsClass extends React.Component {
  constructor() {
    super();

    this.state = {
      editCreditInfo: false,
      countrySelected: _.get(
        this.context,
        "locals.activeUserToRequest.stripe.card.addressCountry",
        "locals.activeUserToRequest.country"
      ),
      stateSelected: _.get(
        this.context,
        "locals.activeUserToRequest.stripe.card.addressState",
        null
      ),
    };

    this.handleCreditToggle = this.handleCreditToggle.bind(this);
  }

  componentDidMount() {
    loadStripeCard(FORM_ID, this.stripeTokenHandler);
  }

  stripeTokenHandler(res) {
    submit("/actions/billing/update/source", {
      method: "POST",
      body: {
        source: loadStripeCard.getSourceValues(),
        stripeToken: res,
      },
    });
  }

  handleCreditToggle() {
    this.setState({ editCreditInfo: !this.state.editCreditInfo }, () => {
      loadStripeCard(FORM_ID, this.stripeTokenHandler);
    });
  }

  handleCountrySelect(e) {
    this.setState({ countrySelected: e.target.value });
  }
  handleStateSelect(e) {
    this.setState({ stateSelected: e.target.value });
  }

  render() {
    const { t } = this.props;
    const { locals, req } = this.context;
    const {
      activeUser,
      organizationOwner,
      getCountryName,
      countries: countryOptions,
    } = locals;
    const userIsCoach = activeUser.permissions?.includes("coach");
    const card =
      (!activeUser.organizationId && !organizationOwner) || !userIsCoach
        ? _.get(activeUser, "stripe.card", {})
        : _.get(organizationOwner, "stripe.card", {});
    const cardType = _.chain(activeUser)
      .get("stripe.card.brand", "")
      .replace(" ", "-")
      .lowerCase()
      .value();
    const {
      addressLine1,
      addressLine2,
      addressCity,
      addressZip,
      addressCountry,
      addressState,
    } = card ? card : {};
    const addressLine2Render = addressLine2 === null ? "" : addressLine2;

    return (
      <main className="settings manage-billing">
        <SettingsNav />
        <form
          method="POST"
          action="/actions/billing/update/source"
          id={FORM_ID}
          className="manage-billing"
        >
          <h3 className="force-mobile-hidden">{t("settingsBilling.manageBilling")}</h3>
          <SettingsBackHandler title={t("settingsBilling.manageBilling")} />
          <p className="s2 -mt-4 mb-8">
            {t("settingsBilling.manageCardDescription")}
          </p>

          {_.isEmpty(card) ? (
            <div>
              <div className="column" data-col="1/2">
                <div className="label" htmlFor="card-element">
                  {t("settingsBilling.creditCardInformation")}
                </div>
                <StripeCardComponent />
              </div>

              <div className="column" data-col="1/2" />

              <div className="column" data-col="1/2" />
            </div>
          ) : (
            <>
              {(!this.state.editCreditInfo || req.query.closeEditCredit) && (
                <div className="payment-details">
                  <label>{t("settingsBilling.yourPaymentDetails")}</label>
                  <div className="card-details">
                    <SvgIcon
                      className="cc-brand"
                      src={`/img/${cardType}-icon.svg`}
                    />
                    <strong>**** **** **** {card.lastFour}</strong>
                    <a
                      role="button"
                      data-button-type="text"
                      href=""
                      onClick={this.handleCreditToggle}
                    >
                      <span>{t("settingsBilling.changeCard")}</span>
                    </a>
                  </div>
                </div>
              )}
            </>
          )}

          {this.state.editCreditInfo && !req.query.closeEditCredit && (
            <div role="input-group">
              <label htmlFor="card-element">{t("settingsBilling.creditCardInformation")}</label>
              <StripeCardComponent />
            </div>
          )}
          <section>
            <div className="input-group">
              <label htmlFor="source[address_line1]">{t("settingsBilling.billingAddress")}</label>
              <input
                className="text-input"
                name="source[address_line1]"
                type="text"
                placeholder={t("settingsBilling.addressLine1")}
                defaultValue={addressLine1}
                sz="large"
              />
            </div>
            <div className="input-group">
              <label htmlFor="source[address_line2]">&nbsp;</label>
              <input
                className="text-input"
                name="source[address_line2]"
                type="text"
                placeholder={t("settingsBilling.addressLine2")}
                defaultValue={addressLine2Render}
                sz="large"
              />
            </div>
            <div className="input-group">
              <label htmlFor="source[address_city]">{t("settingsBilling.city")}</label>

              <input
                className="text-input"
                name="source[address_city]"
                type="text"
                placeholder={t("settingsBilling.cityPlaceholder")}
                defaultValue={addressCity}
                sz="large"
              />
            </div>
            <div className="input-group">
              <label htmlFor="source[address_country]">{t("settingsBilling.country")}</label>
              <select
                required
                name="source[address_country]"
                className="select-input"
                value={
                  this.state.countrySelected
                    ? this.state.countrySelected
                    : _.get(activeUser, "country", "")
                }
                onChange={(e) => this.handleCountrySelect(e)}
              >
                <option hidden disabled value="">
                  {t("settingsBilling.location")}
                </option>
                {_.map(countryOptions, (code) => {
                  return (
                    <option key={code} value={code}>
                      {getCountryName(code)}
                    </option>
                  );
                })}
              </select>
            </div>
            {["AU", "CA", "US"].indexOf(this.state.countrySelected) == -1 && (
              <div className="input-group">
                <label htmlFor="source[address_state]">{t("settingsBilling.state")}</label>
                <input
                  className="select-input"
                  name="source[address_state]"
                  type="text"
                  placeholder={t("settingsBilling.statePlaceholder")}
                  value={this.state.stateSelected}
                  onChange={(e) => this.handleStateSelect(e)}
                />
              </div>
            )}
            {this.state.countrySelected === "CA" && (
              <div className="input-group">
                <label htmlFor="source[address_state]">{t("settingsBilling.province")}</label>

                <select
                  className="select-input"
                  name="source[address_state]"
                  placeholder={t("settingsBilling.provincePlaceholder")}
                  value={this.state.stateSelected}
                  onChange={(e) => this.handleStateSelect(e)}
                >
                  <option disabled value="">
                    {t("settingsBilling.province")}
                  </option>
                  <option value="AB">Alberta</option>
                  <option value="BC">British Columbia</option>
                  <option value="MB">Manitoba</option>
                  <option value="NB">New Brunswick</option>
                  <option value="NL">Newfoundland and Labrador</option>
                  <option value="NS">Nova Scotia</option>
                  <option value="ON">Ontario</option>
                  <option value="PE">Prince Edward Island</option>
                  <option value="QC">Quebec</option>
                  <option value="SK">Saskatchewan</option>
                  <option value="NT">Northwest Territories</option>
                  <option value="NU">Nunavut</option>
                  <option value="YT">Yukon</option>
                </select>
              </div>
            )}

            {this.state.countrySelected === "US" && (
              <div className="input-group">
                <label htmlFor="source[address_state]">{t("settingsBilling.state")}</label>

                <select
                  className="select-input"
                  type="text"
                  name="source[address_state]"
                  value={this.state.stateSelected}
                  onChange={(e) => this.handleStateSelect(e)}
                >
                  <option disabled value="">
                    {t("settingsBilling.state")}
                  </option>
                  {US_STATES.map((state) => (
                    <option value={state.abbreviation}>{state.name}</option>
                  ))}
                </select>
              </div>
            )}

            {this.state.countrySelected === "AU" && (
              <div className="input-group">
                <label htmlFor="source[address_state]">{t("settingsBilling.state")}</label>

                <select
                  className="select-input"
                  type="text"
                  name="source[address_state]"
                  value={this.state.stateSelected}
                  onChange={(e) => this.handleStateSelect(e)}
                >
                  <option disabled value="">
                    {t("settingsBilling.state")}
                  </option>
                  {AU_STATES.map((state) => (
                    <option value={state.abbreviation}>{state.name}</option>
                  ))}
                </select>
              </div>
            )}
            <div className="input-group">
              <label htmlFor="source[address_zip]">
                {this.state.countrySelected === "US"
                  ? t("settingsBilling.zipCode")
                  : t("settingsBilling.postalCode")}
              </label>
              <input
                className="text-input"
                name="source[address_zip]"
                type="text"
                placeholder={
                  this.state.countrySelected === "US"
                    ? t("settingsBilling.zipCode")
                    : t("settingsBilling.postalCode")
                }
                defaultValue={addressZip}
              />
            </div>
          </section>

          <button type="submit" data-button-type="primary">
            {t("common:save")}
          </button>
        </form>
      </main>
    );
  }
}

const BillingDetails = withTranslation("dashboard")(BillingDetailsClass);

const Billing = (app) => {
  app.get(
    "/billing",
    set("heading", "Billing"),
    ({ res, req, locals, session }) => {
      const { query } = req;

      if (locals.activeUser.coach) {
        res.redirect("/logout");
      }
      // Redirect to upgrade page if user is on free trial
      const userIsCoach = locals.activeUser.permissions?.includes("coach");
      const plan =
        (!locals.activeUser.organizationId && !locals.organizationOwner) ||
        !userIsCoach
          ? _.get(locals.activeUser, "stripe.plan", false)
          : _.get(locals.organizationOwner, "stripe.plan", false);

      if (
        plan == PLANS.LAUNCH.trial ||
        plan == PLANS.V2.trial ||
        locals.activeUser.cancelled
      ) {
        return res.redirect("/upgrade-1");
      }

      const modal = _.get(query, "modal", {});
      locals.modal = {
        cancel: <CancelAccountModal />,
        "update-payment": <UpdatePaymentModal />,
        "upgrade-confirmation": <UpgradeConfirmationModal />,
        "activity-feed": <ActivityDrawer />,
      }[modal.type];

      res.body = (
        <BillingDetails
          activeUser={locals.activeUser}
          showCard={query.action === "updateCard"}
        />
      );
    }
  );
};

export default Billing;
